import styled, { css, keyframes } from 'styled-components';
import * as palette from '../../styles/variables';
import { Button } from 'antd';
const slideInRight = keyframes` 
   from {
     opacity: 0;
     transform: translateX(-20px);
   }
   to {
     opacity: 1;
     transform: translateX(0px);
   }
 `;
export const Container = styled.aside`
  height: ${props => (props.display ? '100%' : '0')};
  display: flex;
  position: relative;
  z-index: 100;
  .docDesign {
    background: linear-gradient(137.73deg, rgb(23 2 60) 3.35%, rgb(219, 57, 31) 97.84%) !important;
  }
  .mailDesign {
    background: linear-gradient(
      10deg,
      rgb(49, 145, 151),
      rgb(175, 0, 45) 41.07%,
      rgb(255, 122, 24) 76.05%
    ) !important;
  }
  .messageDesign {
    background: linear-gradient(
      60deg,
      #f79533,
      #f37055,
      #ef4e7b,
      #a166ab,
      #5073b8,
      #1098ad,
      #0998ad,
      #08a39b
    ) !important;
  }
`;

export const MenuTabs = styled.div`
  height: 100%;
  position: relative;
`;
export const TabsContainer = styled.nav`
  width: 75px;
  height: 100%;
  display: flex;
  flex-direction: column;
  ${props =>
    !props.isEmail &&
    css`
      @media (min-width: 1461px) and (max-width: 2560px) {
        height: calc(100% - 210px);
      }
    `}
  @media only screen and (max-width: 1460px) {
    height: calc(100% - 180px);
  }
`;

export const TabDetails = styled.div`
  width: 75px;
  height: ${props => (props.isEmail ? '55px' : '70px')};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: ${props => (props.active ? '1' : '0.65')};
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
  ${props =>
    !props.isEmail &&
    css`
      @media (min-width: 1461px) and (max-width: 2560px) {
        height: 65px;
      }
    `}
  @media only screen and (max-width: 1460px) {
    height: 58px;
  }
  @media only screen and (max-width: 1440px) {
    height: 52px;
  }
  @media only screen and (max-width: 1240px) {
    height: 48px;
  }
`;

export const TabIcon = styled.div`
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  z-index: 10;
  .settings-icon, .versions-icon {
    font-size: 22px;
  }
  .business-logic {
    fill: #ffffff;
  }
  .accessibility-design {
    fill: #ffffff;
     g {
        stroke: #ffffff;
      }
  }
  .channel-icon {
    path {
      stroke: #fff;
    }
  }
  &.activeTab {
    animation: ${slideInRight} 0.8s ease-in-out 0s forwards;
    .anticon {
      background: #fff;
      border-radius: 50%;
      padding: ${props => props.isEmail ? '5px' : '10px'};
      color: #000 !important;
    }
    .business-logic {
      fill: #000000;
      padding: ${props => props.isEmail ? '2px' : '7px'};
    }
    .accessibility-design { 
      fill : #000000;
      g {
        stroke: #000000;
      }
    }
    .inserts-tab {
      padding: 5px;
    }
    .channel-icon {
      path {
        stroke: #000;
      }
    }
    @media only screen and (max-width: 1460px) {
      .anticon {
        padding: 5px;
      }
    }
  }
  @media only screen and (max-width: 1460px) {
    svg {
      width: 25px;
      height: 25px;
    }
  }
`;

export const TabsActivityContainer = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  width: 75px;
  height: 100%;
  overflow: hidden;
`;
export const TabsActivityHighlighter = styled.div`
  position: fixed;
  left: ${props => (props.isEmail ? '10px' : '0px')};
  top: 5px;
  width: ${props => (props.isEmail ? '65px' : '75px')};
  height: ${props => (props.isEmail ? '55px' : '70px')};
  background: rgb(37, 41, 45);
  opacity: 1;
  z-index: 0;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out,
    -webkit-transform 0.25s ease-in-out;
  &:after,
  &:before {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    overflow: hidden;
    right: 0;
    background: radial-gradient(
        circle closest-side,
        transparent 0,
        transparent 50%,
        rgb(37, 41, 45) 0
      )
      200% 200%/400% 400%;
  }
  &:before {
    top: -10px;
  }
  &:after {
    bottom: -10px;
    transform: scaleY(-1);
  }
  @media only screen and (max-width: 1460px) {
    width: 65px;
    height: 58px;
    left: 10px;
  }
  @media only screen and (max-width: 1440px) {
    height: 52px;
  }
  ${props =>
    !props.isEmail &&
    css`
      @media (min-width: 1461px) and (max-width: 2560px) {
        height: 65px;
      }
    `}
  @media only screen and (max-height: 599px) {
    top: 0;
  }
`;

export const TabExpandContainer = styled.div`
  height: 100%;
  background: ${props => (props.disable ? 'white' : 'rgb(37, 41 ,45)')};
  margin-top: 60px;
  overflow-y: ${props => (props.accessibilitySidebar ? 'none': 'auto')};
  /* Scrollbar customization */
  ::-webkit-scrollbar {
    width: 8px;
  }
  #channel-tab {
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }
  }
  &.showSideBar {
    transition: ${props => !props.versionsTab ? 'width 0.35s ease-in-out 0s' : 'none'};
    width: ${props => props.longSidebar ? '800' : props.variableSidebar ? '586' : '350'}px !important;
    height: 100%;
    margin-top: ${props => props.isSMS ? '70px' : '60px'};
    padding: 10px !important;
    overflow: ${props => props.variableSidebar && 'hidden'};
  }
  &.sidebar-absolute.showSideBar {
    padding: 0 !important;
  }
  &.hideSideBar {
    transition: width 0.35s ease-in-out 0s;
    width: 0px !important;
    height: 0;
    margin-top: 0;
    padding: 0px !important;
  }
  &.variables {
    transition: all 0.4s ease-in-out 0s;
    width: 350px !important;
    padding: 0 !important;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 4px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
  }
  ::-webkit-scrollbar-thumb:window-inactive {
    background: rgb(37, 41, 45);
  }
`;

export const TabMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => (props.isSaveFolder ? '50px' : props.isPreviewTab ? '0px' : '150px')};
  height: ${props => props.isAccessibility && 'calc(100% - 50px)'};
  height: ${props => (props.variableSidebar && '100%')};
  width:${props => (props.complexDesign && '90%')};
  margin:${props => (props.complexDesign && 'auto')};
  height: ${props => (props.complexDesign && '90vh')};
  overflow-y: ${props => (props.complexDesign && 'scroll')};
  overflow-x: ${props => (props.complexDesign && 'hidden')};
  ::-webkit-scrollbar {
      display: none;
    }
  cursor: ${({disabled}) => disabled ? 'not-allowed' : '' };
  * {
    pointer-events: ${({disabled}) => disabled ? 'none' : '' };
  }
  .settings-heading{
    height: 35px;
  }
  .doc-settings-grouping {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 5px;
    .fontSelection {
      margin: 0 !important;
    }
  }
  .doc-settings-width{
    width: 65%;
  }
  .font-size-style{
  margin: 5px 0px 5px;
  height: 40px !important;
  width: 24%;
  }
  .fontSize-button{
   height: 40px !important;
  }
  .summary-editor {
    padding: 10px !important;
    .ql-container {
      height: 200px;

      .ql-editor {
        overflow: auto !important;
      }
    }
  }
  .disabled-editor {
    cursor: not-allowed;
    .summary-editor {
      pointer-events: none;
    }
  }
 .summary-save-button {
    ${(props) => {
      if (!props.isAccessibility) {
        return `
        position: absolute;
        width: 100px;
        height: 30px;
        color: black;
        background-color: #FFEB3B;
        top: -30px;
        right: 0px;
        text-align: center;
        cursor: pointer;
        border-radius: 10px 10px 0px 0px;
        font-weight: 900;
        letter-spacing: 0.6px;
        padding-top: 2px;`
      }
    }}
  }
  .addAttachmentsButton {
    // margin-left: 20%;
    background: ${palette.APP_BRAND_YELLOW_COLOR};
    width: 200px;
    height: 40px;
    text-align: center;
    border: 2px solid ${palette.APP_BRAND_YELLOW_COLOR};
    color: #000;
    font-weight: 500;
    border-radius: 15px;
    z-index: 10 !important;
    &:hover,
    &:focus {
      border: 2px solid ${palette.APP_BRAND_YELLOW_COLOR};
      background: ${palette.APP_BRAND_YELLOW_COLOR};
      color: #000;
    }
  }
  &.mailSettings {
    // height: 20%;
    width: 100%;
    align-items: ${props => props.addAttachment && 'center'};
    margin-bottom: 0px !important;
    .ant-input {
      min-height: 55%;
      height: 70%;
      font-size: 15px;
    }
  }
  &.fixedHeight {
    width: 100%;
    align-items: ${props => props.addAttachment && 'center'};
    margin-bottom: 0px !important;
    height: calc(100% - 60px);
  }
  .categoryContainer {
    margin-top: 88px;
    overflow: auto;
    max-height: 48vh;
    ::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
    @media only screen and (max-width: 1440px) {
      max-height: 45vh;
    }
  }
  &.attachmentTemp {
    align-items: center;
    h2 {
      font-size: 16px !important;
      font-weight: 600;
    }
  }

 .manage-setting-input{
    margin-top: 5px;
    margin-bottom: 5px;
    height: 40px;
    i[aria-label="icon: search"] {
      display: none;
    }
  }
  .warning-message {
    color: orange;
    font-size: 14px;
    margin-top: -10px;
    margin-bottom: 10px;
  }
  .summary-input{
    margin-top: 5px;
    width:99%;
    color: white;
    background-color: transparent;

    }
`;

export const TabMenuHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${props => (props.firstElement && '40px')};
`;

export const TabMenuHeader = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${props => (props.inverted ? '#333' : '#fff')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: ${props => (props.subject ? '5px 0 0 0' : props.isImageCount ? '60px 10px 10px 10px' : '10px 10px 10px')};
  text-transform: uppercase;
  text-align: center;
  // width: calc(100% - 20px);
  display: flex;
  justify-content: center;
  position: relative;
  &.categoryName {
    margin: 20px auto;
    &:before {
      content: '';
      display: block;
      width: 65px;
      height: 2px;
      background: #fff;
      left: 25px;
      top: 50%;
      position: absolute;
    }
    &:after {
      content: '';
      display: block;
      width: 65px;
      height: 2px;
      background: #fff;
      right: 25px;
      top: 50%;
      position: absolute;
    }
    h2 {
      font-size: 14px;
      font-weight: 700;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: 10px 10px 10px;
      text-transform: capitalize;
      text-align: center;
      max-width: 115px;
      color: ${props => (props.inverted ? '#333' : '#ffffff')};
    }
  }
  .see-all {
    cursor: pointer;
    font-weight: 400;
    &:hover {
      text-decoration: underline;
    }
  }
  &.subHeading {
    text-transform: capitalize;
    color: #e4e3e3;
  }
`;

export const OverflowContainer = styled.div`
  height: calc(70vh - 60px);
  overflow: auto;
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

export const TabMenuItemContainer = styled.div`
  display: flex;
  flex-direction: ${props => (props.columnDirection ? 'column' : 'row')};
  flex-wrap: wrap;
  // padding-right: ${props => (props.columnDirection ? '10px' : '')};
  padding-right:0px !important;
  margin-bottom: ${props => (props.subject ? '0' : props.addAttachment ? '100px' : '10px')};
  margin-top: ${props => (props.isSearchView && '80px')};
  position: relative;
  z-index: 101;
  justify-content: ${props=> props.justifyContent ? props.justifyContent : 'center'};
  align-items: ${props => (props.subject ? 'flex-start' : 'stretch')};
  cursor: ${({disabled}) => disabled ? 'not-allowed' : '' };
  * {
    pointer-events: ${({disabled}) => disabled ? 'none' : '' };
  }
  
  .buttonItem {
    margin: 10px 0 0 10px;
    padding: 5px 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    border: 1px solid rgba(14, 19, 24, 0.7);
    width: 70%;
    height: 50px;
    border-radius: 10px;
    
    .overflowText {
      max-width: 150px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .ant-select-selection {
    background-color: #fc6e511c;
    color: #fff;
    border: 1.9px solid hsla(0,0%,100%,0.4);  
    margin: 5px 0;
    font-size: 15px;
    font-weight: 600;
  }
  .ant-select-arrow {
    color: #fff !important;
  }
  .ant-select-selection:hover{
    border:1.5px solid #fff !important; 
  }
  .ant-select-selection:focus, .ant-select-selection:active {
    border-color: #fff;
    border-right-width: 1px !important;
    outline: 0;
    box-shadow: none !important;
  }  
  .ant-select-disabled .ant-select-selection {
    background: #f5f5f5;
    cursor: not-allowed;
    color: #c7c7c7 !important;
    font-weight: 500 !important;
  }
  &.email-tag-settings {
    .ant-select-selection {
      background-color: #f5f5f5 !important;
      font-weight: 500 !important;
      color: #c7c7c7 !important;
    }
  }
`;

export const TabMenuItemDetails = styled.div`
  position: relative;
  flex-basis: ${props => (props.size && props.size === 'big' ? '140px' : '')};
  min-height: ${props => (props.size && props.size === 'big' ? '150px' : '')};
  flex-grow: 1;
  max-height: ${props =>
    props.size && props.size === 'big' ? '100%' : props.type === 'element' ? '160px' : '150px'};
  max-width: ${props =>
    props.type && (props.type === 'image' || props.type === 'page') ? '152px' : '312px'};
  height: ${props =>
    props.type && (props.type === 'image' || props.type === 'page')
      ? '150px'
      : props.type === 'element'
      ? '160px'
      : ''};
  width: ${props =>
    props.size && (props.size === 'big' || props.size === 'full') ? '100%' : '140px'};
  margin: 10px 0px 0px 10px;
  transition: transform 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93) 0s;

  .copy-button {
  position: absolute;
  right: 4px;
  top: 120px;
  background-color: rgba(14, 19, 24, 0.7);
  color: #ffffff;
  padding: 2px;

  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s ease;

  &:hover {
    background-color: rgb(0 0 0 / 0.5);
  }
}

/* parent hover controls visibility */
&:hover .copy-button {
  opacity: 1;
  visibility: visible;
}


  .element-meta {
    display: none;
    align-items: center;
    position: absolute;
    right: 4px;
    top: 4px;
    background-color: rgba(14, 19, 24, 0.7);
    color: #ffffff;
    padding: 2px;
    width: 20px;
    height: 16px;
    border-radius: 4px;
    &:hover {
      background-color: rgb(0 0 0 / 0.5);
    }
    .anticon-more {
      transform: rotate(90deg);
    }
    .ant-dropdown {
      top: 20px !important;
      right: 2px !important;
      left: initial !important;
      .ant-dropdown-menu {
        min-width: 100px;
      }
      .ant-dropdown-menu-item {
        font-weight: bold;
        font-size: 14px;
        padding: 4px 12px;
      }
    }
  }
  .preview-button {
    background-color: rgba(14, 19, 24, 0.7);
    color: #ffffff;
    width: 22px;
    height: 18px;
    border-radius: 5px;
    display: none;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 15px;
    right: 10px;
    font-size: 14px;
    .anticon {
      color: #fff;
    }
    &:hover {
      background-color: rgb(0 0 0 / 0.5);
    }
  }
  &:hover {
    cursor: pointer;
    transform: scale(1.05) translate(0px, 0px) perspective(500px);
    .element-meta {
      display: flex;
    }
    .preview-button {
      display: flex;
    }
  }
`;

export const PageCountIndicator = styled.div`
  position: absolute;
  bottom: 15px;
  left: 0px;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  .page-counter {
    background-color: rgba(14, 19, 24, 0.7);
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    white-space: nowrap;
    padding: 0px 6px;
    border-radius: 6px;
  }
`;

export const SidebarCloseMenu = styled.div`
  display: flex;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -12px;
  width: 25px;
  z-index: 100;
  &:hover {
    cursor: pointer;
  }
  .anticon-left {
    font-size: 12px;
    position: absolute;
    right: 2px;
    top: 50%;
    transform: translateY(-50%);
    color: #ffffff;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${props => props.top || '150px'};
  .loading-txt {
    font-size: 14px;
    color: #ffffff;
    margin-top: 20px;
  }
`;

export const EmptyElements = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 150px;
  &.full-width {
    width: 100%;
  }
  .empty-illustration {
    max-width: 120px;
    .anticon {
      font-size: 42px;
    }
  }
  .empty-txt {
    max-width: 245px;
    font-size: 14px;
    color: #ffffff;
    margin-top: 20px;
    .empty-links {
      text-decoration: underline;
      color: #2c8fc7;
      font-weight: bold;
      &:hover {
        cursor: pointer;
      }
    }
  }
`;

export const SettingsList = styled.div`
  padding: 20px 5px;
`;

export const SummaryContainer = styled.div`
    margin-top: 20px !important;
`;

export const SettingsHeading = styled.p`
  font-size: ${props => props.email ? '14px' :'16px'};
  font-weight: 700;
  display: ${props => props.folder && 'flex'};
  justify-content: ${props => props.folder && 'space-between'};
  align-items: ${props => props.folder && 'center'};
  color: ${props => (props.complexEmailDesign ? '#000' : props.email ? "#fff" : "rgb(255 255 255 / 0.75)")};
  margin: ${props =>
  props.folder ? '0' : props.docName ? '0 !important' : props.complexDesign ? '5px 0px 0px 0px !important' : '0px 0px 25px !important'};
  padding: ${props => (props.folder || props.email ? '0' : props.complexDesign || props.docName ? '5px 0px 0px 0px': '0px 0px 8px !important')};
  margin-top: ${props => props.folder && '-25px !important'};
  margin-bottom: ${props => props.folder && '20px !important'  };
  margin-left: ${props => props.folder && '-10px !important'};
  padding: ${props => props.folder && '5px !important'};
  // margin-top:100px;
  .anticon-left {
    padding: 10px;
    border-radius: 50%;
    &:hover {
      background-color: hsla(0, 0%, 100%, 0.07);
      cursor: pointer;
      color: #fff;
    }
  }
  &.with-icon {
    padding: 0px 0px 5px;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.15);
  }
  margin-top: ${props => props.cloneable && '14px !important'}; 
  .ant-switch {
    margin-left: 20px;
  }
`;

export const FontFamilyInput = styled.div`
  display: flex;
  gap: 10px;
  // margin: ${props => props.complexEmailDesign ?'5px 0px 0px 10px' : props.complexDocumentDesign?'5px 0px 5px 0px' : '10px 0px 20px'};
  // width: ${props => props.complexEmailDesign && '90%'};
  width: 90% !important;
  .input {
    width: 100%;
    border-radius: 4px;
    display: flex;
    padding: 8px;
    cursor: pointer;
    background-color:#fff;
    border: ${props => props.complexEmailDesign ? '1px solid #d9d9d9' : '0px'}
    &:hover{
      border: ${props => props.complexEmailDesign ? '1px solid #000' : '0px'}
    }
  }
  & span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
  }
`;

export const SizeButton = styled(Button)`
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: ${props => (props.width ? props.width + 'px !important' : `auto !important`)};
  border: 1px solid #fff !important;
  background-color: #fff !important;
  border-radius: ${props => (props.radiusLeft ? '4px 0px 0px 4px' : '0px 4px 4px 0px')} !important;
  height: 35px !important;
  // background: ${props => props.comboBox && 'rgb(37, 41, 45) !important'};
  padding: 0 10px !important;
  margin-right: ${props => (props.comboBox && !props.isMinus && '15px')};
  z-index: 10;
  &:hover {
    background-color: #e8e8e8 !important;
  }
  i {
    padding-right: ${props => (props.comboBox ? '0' : '12px')};
    margin-top: ${props => (props.comboBox ? '0' : '-29px')};
    color: #000;
  }
  input {
    width: 50px;
    height: 99%;
    text-align: center;
    border-radius: unset;
    border-color: transparent;
    margin: 0px -15px;
    z-index: 100;
  }
  span {
    width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #fff;
  }
`;

export const SizeContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 350px;
  width: 40px;
  li {
    cursor: pointer;
    padding: 5px 4px;
    &:hover,
    &:focus {
      background-color: rgba(14, 19, 24, 0.07) !important;
    }
  }
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const BreadCrumbHeading = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: rgb(255 255 255 / 0.75);
  margin: ${props => (props.folder ? '0' : '0px 0px 25px !important')};
  padding: ${props => (props.folder ? '0' : '0px 0px 8px !important')};
  margin-top: ${props => props.folder && '-10px !important'};
  margin-bottom: ${props => props.folder && '20px !important'};
  margin-left: ${props => props.folder && '-10px !important'};
  padding: ${props => props.folder && '5px !important'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  .anticon-left {
    margin: ${props => (props.folder ? '0' : '4px 5px 0px 0px')};
    padding: 10px;
    border-radius: 50%;
    &:hover {
      background-color: hsla(0, 0%, 100%, 0.07);
      color: #fff;
    }
  }
  .ant-breadcrumb {
    font-size: 15px;
    color: rgb(255 255 255 / 0.75);
    flex-wrap: wrap;
    display: flex;
  }
  .ant-breadcrumb span:last-child .ant-breadcrumb-link {
    color: #fff !important;
    font-weight: 700 !important;
  }
  .ant-breadcrumb-link {
    cursor: pointer !important;
    color: rgb(255 255 255 / 0.75);
    &:hover {
      color: #fff !important;
      font-weight: 700;
      text-decoration: underline !important;
    }
  }
  .ant-breadcrumb-separator {
    color: rgb(255 255 255 / 0.75);
    cursor: default !important;
  }
  .separator {
    font-size: 15px;
    color: rgb(255 255 255 / 0.75);
  }
`;

export const SettingsListCard = styled.div`
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 10px;
  .settings-list-icon {
    width: 56px;
    height: 56px;
    padding: 14px;
    background-color: #fff;
    border-radius: 4px;
  }
  .settings-list-meta {
    display: flex;
    flex-direction: column;
    padding-left: 16px;
    .settings-list-name {
      font-size: 14px;
      color: #fff;
      font-weight: 600;
    }
    .settings-list-details {
      font-size: 12px;
      color: hsla(0, 0%, 100%, 0.65);
    }
  }
  &:hover {
    background-color: hsla(0, 0%, 100%, 0.07);
    cursor: pointer;
  }
  .anticon {
    font-size: 25px;
    color: #000;
  }
`;

export const SettingsListDetails = styled.div`
  padding: 10px 5px 20px 5px;
`;

export const EmptySettingsDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${props => (props.emptyfolder ? '50px' : '150px')};
  .empty-illustration {
    max-width: 120px;
  }
  .empty-txt {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    max-width: 245px;
    font-size: 14px;
    color: ${props => (props.inverted ? '#333' : '#ffffff')};
    margin-top: 20px;
    span {
      margin-right: 5px;
      text-align: center;
    }
    .empty-links {
      text-decoration: underline;
      color: #2c8fc7;
      font-weight: bold;
      &:hover {
        cursor: pointer;
      }
    }
  }
`;

export const SettingsCategoryOverview = styled.div`
  width: 100%;
  background-color: hsla(0, 0%, 100%, 0.07);
  padding: 14px;
  transition: background-color 0.2s ease-in-out;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  border-radius: 4px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .category-overview-name {
    max-width: 250px;
    overflow: hidden;
    color: #fff;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .category-overview-actions {
    display: flex;
  }
  .category-action {
    margin-left: 5px;
    padding: 7px;
    color: rgb(255 255 255 / 0.6);
    transition: all 0.2s ease-in-out;
    &:hover {
      cursor: pointer;
      transform: scale(1.1);
      color: #ffffff;
    }
  }
  &:hover {
    /* cursor: pointer; */
    background-color: hsla(0, 0%, 100%, 0.15);
  }
`;

export const HelpGuideWrapper = styled.div`
  width: ${props => (props.isSaveFolder ? '350px' : '327px')};
  position: absolute;
  bottom: 0px;
  left: ${props => props.isSaveFolder && '75px'};
  z-index: 105;
  .help-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${props => (props.isSaveFolder ? 'rgb(37,41 ,45)' : '#0e1318')};
    padding:${props => (props.complexDesign ? '10px' : '15px')};
    column-gap: ${props => (props.complexDesign ? '10px' : '')};
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    &.upload-helper {
      flex-direction: row;
      justify-content: center;
    }
    .ant-upload {
      // min-width: 200px;
    }
    .help-icon {
      width: 75px;
      margin-top: -10px;
      margin-right: 20px;
    }
    .help-text-details {
      display: flex;
      flex-direction: column;
    }
    .ideation-icon {
      width: 15px;
    }
    .ideation-txt {
      font-size: 12px;
      color: #ffffff;
    }
    .help-action-btn {
      width: 100%;
      min-width: fit-content;
      max-width: ${props => props.reusable ? '215px': '200px'};
      font-size: 14px;
      text-align: center;
      padding: 5px;
      height: ${props => props.isSaveFolder && '40px'};
      border-radius: ${props => (props.isSaveFolder ? '15px' : '4px')};
      background-color: ${props =>
        props.isSaveFolder ? `${palette.APP_BRAND_YELLOW_COLOR}` : 'hsla(0, 0%, 100%, 0.95)'};
      color: #0e1318;
      border: 2px solid transparent;
      font-weight: 600;
      margin: auto;
      &:hover {
        cursor: ${props => (props.isTemplateSaved ? 'not-allowed' : 'pointer')};
        background-color: ${props =>
          props.isSaveFolder ? `${palette.APP_BRAND_YELLOW_COLOR}` : '#fff'};
        color: #0e1318;
      }
    }
    .generate-image-act-btn {
      max-width: 200px;
      font-size: 14px;
      text-align: center;
      height: ${props => props.isSaveFolder && '40px'};
      border-radius: ${props => (props.isSaveFolder ? '15px' : '4px')};
      background-color: ${props =>
        props.isSaveFolder ? `${palette.APP_BRAND_YELLOW_COLOR}` : 'hsla(0, 0%, 100%, 0.95)'};
      color: #0e1318;
      border: 2px solid transparent;
      font-weight: 600;
      margin-left: 10px;
      padding: 4px 5px;
      &:hover {
        cursor: ${props => (props.isTemplateSaved ? 'not-allowed' : 'pointer')};
        background-color: ${props =>
          props.isSaveFolder ? `${palette.APP_BRAND_YELLOW_COLOR}` : '#fff'};
        color: #0e1318;
      }
    }
  }
`;
export const DragContainer = styled.div`
  width: 100%;
  height: 100%;
  & span {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  & .ant-upload.ant-upload-drag {
    width: 100% !important;
    height: 100%;
    background-color: transparent !important;
    border: unset !important;
    cursor: initial !important;
  }
  & .ant-upload-btn {
    display: flex !important;
    min-height: calc(100vh - 150px) !important;
    align-items: center;
    justify-content: flex-start;
  }
  & .ant-upload-text {
    color: white !important;
    margin: 0 30px !important;
  }
  .ant-upload-drag-container {
    width: 100%;
    height: 100%;
  }
  .ant-upload.ant-upload-drag .ant-upload {
    padding: ${props => props.isSearched && '50px 0'};
    cursor: default;
  }
`;

export const TemplatePageOverview = styled.div`
  position: relative;
  width: ${props => (props.masterTemplate ? '200px' : '225px')};
  height: ${props => (props.inverted ? '370px' : props.masterTemplate ? "323px" : props.isMailTemplates ? '370px' : '400px')};
  margin: 10px 0px 0px 10px;
  transition: transform 0.2s cubic-bezier(0.33, 0.04, 0.63, 0.93) 0s;
  .template-media {
    height: 100%;
    position: relative;
    padding: ${props => (props.inverted ? '10px' :  '5px')};
    border-radius: ${props => (props.inverted ? '20px' :  '10px')};
    height: ${props => (props.inverted ? '250px' : props.masterTemplate ? "285px" :'315px')};
    background: #fff !important;
    border: none;
    box-shadow: ${props => (props.inverted ? '0 .1rem 3rem rgba(0,0,0,13%)' : 'none')};
    margin: ${props => (props.inverted ? '20px' : '0')};
  }
  .template-name {
    font-size: ${props => (!props.inverted ? '16px' : '18px')};
    color: ${props => (props.inverted ? '#333' : '#fff')};
    padding: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    text-transform: uppercase;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    h2 {
      font-family: ambroise-firmin-std, serif;
      color: ${props => (props.inverted ? '#333' : '#fff')};
      font-size: 18px !important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre;
      text-align: center;
      max-width: 350px;
      // filter: invert(1);
      // mix-blend-mode: difference;
    }
  }
  .image-wrapper {
    height: 100%;
    img {
      max-height: 305px;
      object-fit: contain;
      background: transparent;
      color: transparent;

      &.no-thumbnail {
        height: 100%;
        margin-top: 15%;
        object-fit: ${props => !props.attachmentTemp && 'none'};
        // width: auto;
        // max-width: fit-content;
      }

      &.no-margin {
        margin-top: 0;
      }
    }
    // .no-thumbnail-info {
    //   font-size: 10px;
    //   color: rgb(255 255 255 / 0.45);
    //   text-align: center;
    //   margin: 5px 0px 35px;
    // }
  }
  .show-loader {
    background-image: url('./generatingPreview.png');
    background-repeat: no-repeat;
    background-position: center;

    img {
      visibility: hidden;
    }
  }
  .preview-button {
    background-color: rgba(14, 19, 24, 0.7);
    color: #ffffff;
    width: 22px;
    height: 18px;
    border-radius: 5px;
    display: none;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 15px;
    right: 10px;
    font-size: 14px;
    .anticon {
      color: #fff;
    }
    &:hover {
      background-color: rgb(0 0 0 / 0.5);
    }
  }
  &:hover {
    cursor: pointer;
    transform: scale(1.05) translate(0px, 0px) perspective(500px);
    .dropdown-menu {
      display: flex;
    }
    .preview-button {
      display: flex;
    }
  }
  .ant-checkbox {
    margin-right: 5px;
  }
  .ant-checkbox,
  .ant-checkbox-inner {
    width: 25px;
    height: 25px;
  }
  .ant-checkbox-inner {
    border: 2px solid white;
    &::after {
      border-color: black !important;
    }
  }
  .ant-checkbox .ant-checkbox-inner {
    background-color: white !important;
    border-color: black !important;
  }

  .preview-button1 {
    background-color: red;
    color: #ffffff;
    width: 22px;
    height: 18px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0px;
    left: 0px;
    font-size: 14px;
 
   
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;    
  }
  
  .circle {
    position: relative;
    background: #835bf6;
    border-radius: 100%;
    height: 30px;
    width: 30px;
  }
  
  .checkMark {
    position: absolute;
    transform: rotate(50deg) translate(-50%, -50%);
    left: 22%;
    top: 47%;
    height: 19px;
    width: 10px;
    border-bottom: 3px solid #fff;
    border-right: 3px solid #fff;
  }
  
  .editable-icon-tag {
    position: absolute;
    bottom: 15px;
    left: 10px;
    background: rgba(14, 19, 24, 0.7);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
    width: 22px;
    height: 18px;
  }
  
`;

export const SubTabHeading = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  color: rgb(255 255 255 / 0.75);
  margin: ${props => (props.Master ? "40px 0px 25px" : '0px 0px 25px')};
  padding: 0px 0px 0px 8px;
  .subtab-name {
    max-width: 265px;
  }
  .anticon-left {
    padding: 10px;
    border-radius: 50%;
    &:hover {
      background-color: hsla(0, 0%, 100%, 0.07);
      cursor: pointer;
      color: #fff;
    }
  }
  &.with-icon {
    padding: 0px 0px 5px;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.15);
  }
`;

export const DropdownDetails = styled.div`
  display: none;
  align-items: center;
  position: absolute;
  right: 10px;
  top: 10px;
  background-color: ${props => (props.vertical ? 'rgb(14 19 24 / 0%)' : 'rgba(14, 19, 24, 0.7)')};
  color: #ffffff;
  padding: 2px;
  width: 20px;
  height: 16px;
  border-radius: 4px;
  &.dropdown-visible {
    position: relative;
    display: flex;
    top: initial;
    right: initial;
    margin-left: auto;
  }
  &:hover {
    background-color: ${props => (props.vertical ? '' : 'rgb(0 0 0 / 0.5)')};
  }
  .anticon-more {
    transform: ${props => (props.vertical ? 'rotate(180deg)' : 'rotate(90deg)')};
  }
  .ant-dropdown {
    top: 20px !important;
    right: 2px !important;
    left: initial !important;
    z-index: 100001;
    .ant-dropdown-menu {
      min-width: 100px;
    }
    .ant-dropdown-menu-item {
      font-weight: bold;
      font-size: 14px;
      padding: 6px 12px;
      margin: 1px 0px;
    }
  }
`;

export const NoDataView = styled.div`
  font-size: ${props => (props.small ? '12px' : '16px')};
  color: white;
  text-align: center;
  margin-top: 35px;
`;

export const TabSearchContainer = styled.div`
  position: absolute;
  top: ${props => (props.Master || props.marginTop ? '48px' : '0px')};
  z-index: 105;
  background: ${props => (props.absolute ? '#293039' : '')};
  text-align: center;
  background: ${props => (props.inverted ? 'transparent' : ' rgb(37, 41, 45)')};
  padding: 10px;
  .ant-input-affix-wrapper {
    width: 312px !important;
    height: 40px !important;
    border: 1px solid #293039;
    .ant-input-suffix {
      i {
        padding: 0 5px;
        .anticon-control {
          transform: rotate(90deg);
        }
      }
    }
    .ant-input {
      padding: 0px 65px 0px 45px !important;
      outline: none !important;
      border: none !important;
      &:focus {
        outline: none !important;
        border: none !important;
      }
    }
  }
  i {
    font-size: 16px !important;
    color: black !important;
  }
  .ant-popover {
    left: 175px !important;
  }
  .ant-badge-dot {
    top: 5px !important;
    right: 9px !important;
    background-color: #df4c35;
    color: #df4c35;
  }
`;

export const PopoverContainer = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  .ant-btn-primary {
    margin-top: 15px;
    background-color: rgb(219 57 31 / 85%);
    color: #ffffff;
    border-radius: 4px;
    border-color: transparent;
    &:hover,
    &:focus {
      background-color: rgb(219 57 31 / 95%);
      color: #ffffff;
      border-color: transparent;
    }
  }
`;

export const NoteText = styled.p`
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
  color: white;
`;

export const ClearAll = styled.div`
  position: absolute;
  top: 10px;
  right: 5px;
  font-size: 12px;
  padding: 12px;
  color: #df4c35;
  font-weight: 600;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  .warning-text {
    max-width: 500px;
    text-align: center;
    font-size: 18px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    span {
      margin-right: 5px;
      &.text-highlighter {
        font-weight: bold;
      }
    }
  }
`;

export const SearchNavWrapper = styled.div`
  width: 340px;
  position: absolute;
  top: 0px;
  z-index: 105 !important;
  background: rgb(37, 41, 45) !important;
  margin-top: 60px;
  .ant-tabs-nav {
    color: rgb(255 255 255 / 0.65) !important;
    font-weight: 600 !important;
    .ant-tabs-tab-active {
      color: #ffffff !important;
      font-weight: 700 !important;
    }
    .ant-tabs-tab {
      &:active {
        color: #ffffff !important;
      }
      &:hover {
        color: #ffffff !important;
      }
    }
  }
  .ant-tabs-ink-bar {
    background-color: #ffffff !important;
  }
  .ant-tabs-bar {
    border-bottom: #ffffff00 !important;
  }
  .ant-tabs-nav-wrap {
    text-align: center;
  }
  .ant-tabs-nav-container.ant-tabs-nav-container-scrolling {
    .ant-tabs-tab-arrow-show {
      color: #ffffff;
      i {
        &.ant-tabs-tab-next-icon-target, &.ant-tabs-tab-prev-icon-target {
          font-size: 20px;
        }
      }
    }
  }
`;
export const ElementNavWrapper = styled(SearchNavWrapper)`
  .ant-tabs-tab {
    padding: 12px 0px !important;
  }
`;
export const ListContainer = styled.div`
  display: flex;
  height: calc(100% - 100px);
  overflow-y: ${props => props.channelTab ? 'visible' : 'auto'};
  overflow-x: ${props => props.channelTab ? 'visible' : 'hidden'};; /* Hide horizontal scrollbar */
  z-index: 99;
  ul {
    ${props => props.channelTab && 'width: 100%'}
  }
  .channel-list {
    &:hover {
      background: #8C52FF;
      cursor: pointer;
    }
  }
  li {
    padding: 0 20px;
    min-height: 40px;
    width: ${props => !props.channelTab && '327px'};
    align-items: center;
    display: flex;
    cursor: ${props => (props.noHover && !props.channelTab ? 'auto' : 'pointer')};
    font-weight: 300;
    ${props => props.channelTab && 
      `justify-content: space-between;`
    }
    &:hover {
      background: ${props => (props.noHover ? 'none' : 'lightgray')};
      color: ${props => (props.noHover ? 'none' : 'black')};
      .changeIcon{
        fill:black;
      }
    }
    .changeIcon{
      fill:white;
    }
    span {
      div {
        ${props => props.channelTab && `
          font-size: 18px;
        `}
      }
      &:first-child {
        width: ${props => props.channelTab ? 'auto' : '90%'};
      }
      &:last-child {
        display: flex;
        align-items: center;
      }
    }
  }
  li:last-child {
    margin-bottom: ${props => props.noHover && !(props.noMargin || false) && '56px'};
  }
  button {
    display: flex !important;
    align-items: center !important;
  }
  .animate {
    position: relative;
    // opacity: 0;
    top: -50px;
    transition: all 0.5s linear;
    max-height: fit-content;
    pointer-events: none;

    &.show {
      top: 0;
      opacity: 1;
      z-index: 2;

      .enableHover {
        &:hover {
          background: lightgray;
          color: black;
          .changeIcon {
            fill:black;
          }
        }
      }

      &.disabled {
          opacity: 0.5;
          pointer-events: none !important;
      }
    }
    &.hide {
      top: -50px;
      opacity: 0;
      height: 0;
      z-index: 0;
    }
  }
  .collapse {
    position: relative;
    transition: all 0.5s linear;
    max-height: fit-content;
    padding-left: 20px;
    overflow-y: scroll;
    scrollbar-width: none;
    -webkit-scrollbar {
      display: none; /* Chrome, Safari */
    }
    &.show {
      opacity: 1;
      height: 100%;
      top: 0;
      z-index: 2;
      pointer-events: all;
    }
    &.hide {
      opacity: 0;
      height: 0;
      top: -50px;
      z-index: 0;
      pointer-events: none;
      overflow: auto;
    }
  }
`;

export const HeaderText = styled.div`
  padding: 10px;
  font-weight: bold;
  position: relative;
  transition: all 0.2s ease-in;
  display: flex;
  justify-content: space-between;

  &.animate {
    top: -10px;
    opacity: 0;
  }

  &.visible {
    top: 0;
    opacity: 1;
  }
`;

export const PremiumIcon = styled.img`
  position: absolute;
  right: 8px;
  top: 8px;
  width: 22px;
  height: 22px;
`;

export const IconMenuItem = styled.div`
  position: relative;
  flex: 1;
  min-width: 120px;
  min-height: 120px;
  margin: 10px;
  text-align: center;
  transition: transform 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93) 0s;

  &:hover {
    cursor: pointer;
    transform: scale(1.05) translate(0px, 0px) perspective(500px);

    .dropdown-menu {
      display: flex;
    }
  }

  .anticon {
    font-size: 45px;
    /*color: rgba(235, 244, 253, 0.45);*/
    @media only screen and (max-width: 1460px) {
      font-size: 35px !important;
    }
  }

  .ql-editor * {
    cursor: pointer;
  }
  &.mailElements {
    min-height: 0 !important;
    will-change: transform;
  }
`;

export const Logo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: ${props => (props.messageStudio ? '240px' : '180px')};
  /*@media (max-height: 680px) {
    height: ${props => !props.messageStudio && '160px'};
  }*/
  &:after {
    content: '';
    height: ${props => (props.messageStudio ? '240px' : '200px')};
    border-left: 75px solid #fff;
    border-bottom: 5vh solid transparent;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 1;
    @media only screen and (min-width: 1460px) {
      height: ${props => (props.messageStudio ? '264px !important' : "225px !important")};
      border-bottom: 6vh solid transparent;
    }
  }
  .name {
    z-index: 2;
    font-size: 14px;
    writing-mode: vertical-rl;
    text-orientation: sideways; // sideways-right
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
    padding: ${props => (props.messageStudio ? '4px 0' : '0px')};
    // text-align: center;
    // height: 120px;
  }
  a {
    z-index: 2;
  }
`;
export const AppLogo = styled.div`
  // margin: 5px;
  // margin-right: 10px;
  /* margin-top: -15px; */
  svg {
    width: 27px;
    transform: rotate(-45deg);
  }
`;
export const SideBarContent = styled.div`
  z-index: 11;
  background: ${props => (props.disable ? 'transparent' : 'rgb(37, 41 ,45)')};
  // box-shadow: 0 16px 38px -12px rgb(0 0 0 / 56%), 0 4px 25px 0 rgb(0 0 0 / 12%),
  //  0 8px 10px -5px rgb(0 0 0 / 20%);
  box-shadow: 12px 16px 38px -12px rgb(0 0 0 / 5%), 12px 4px 25px 0 rgb(0 0 0 / 8%),
    12px 8px 10px -5px rgb(0 0 0 / 10%);
`;
export const TemplateName = styled.div`
  color: #fff;
  position: absolute;
  width: 100vw;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgb(37, 41, 45) !important;
  box-shadow: 16px 0 38px -12px rgb(0 0 0 / 56%), 4px 0 25px 0 rgb(0 0 0 / 12%),
    8px 0 10px -5px rgb(0 0 0 / 20%);
  z-index: 10;
  pointer-events: ${({previewEnabled}) => (previewEnabled && 'none')};

  .blur-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(1px);
    background-color: rgba(2, 2, 2, 0.5); 
    pointer-events: none;
    z-index: 11;
  }
  .current-version {
    padding-inline: 8px;
    white-space: nowrap;
  }
`;
export const FileWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 6px 0px 12px !important;
  .anticon-down {
    font-size: 16px !important;
    padding-left: 5px !important;
    color: #ffffff !important;
    padding-top: 1px !important;
  }
`;

export const VariableCounter = styled.div`
  position: absolute;
  width: 18px;
  height: 18px;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2c94c;
  border: 1.3px solid #ffffff;
  right: 8px;
  top: 6px;
  border-radius: 100%;
  @media only screen and (max-width: 1460px) {
    right: 12px;
    top: 10px;
  }
  .docVarCount {
    font-size: 10px;
    font-weight: bold;
    color: #000000;
  }
`;

export const MailSettingsTab = styled.div`
  height: 61%;
  overflow: hidden;
  @media screen and (max-height: 640px) {
    height: 56%;
  }
  .ant-tabs-nav {
    color: rgb(255 255 255 / 0.65) !important;
    font-weight: 600 !important;
    .ant-tabs-tab-active {
      color: #ffffff !important;
      font-weight: 700 !important;
    }
    .ant-tabs-tab {
      &:active {
        color: #ffffff !important;
      }
      &:hover {
        color: #ffffff !important;
      }
    }
  }
  .ant-tabs-ink-bar {
    background-color: #ffffff !important;
  }
  .ant-tabs-bar {
    border-bottom: #ffffff00 !important;
  }
  .ant-tabs-nav-wrap {
    text-align: center;
  }
  /*@media only screen and (min-width: 1460px){
    height:500px;
  }*/
  
`;

export const DisplayNameInput = styled.div`
  margin-block: 5px;
  padding: 5px;
  min-height: 40px;
  width: 100%;
  background: white;
  border: 1px solid black;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .ql-editor {
    padding: 0;
  }
  .ql-container.ql-snow {
    border: none;
  }
`;